<template>
  <div id="app">

    <b-navbar toggleable="md" class="fixed-top navbar-dark">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <b-navbar-brand href="#home"><img src="./assets/logo_white.svg" class="logo"></b-navbar-brand>

        <b-collapse is-nav id="nav_collapse">
            <b-navbar-nav class="ml-auto">
                <b-navbar-nav right v-b-scrollspy:nav-scroller.75>
                    <b-nav-item class="nav-link" href="#stavby">Stavby</b-nav-item>
                    <b-nav-item class="nav-link" href="#prodej">Prodej</b-nav-item>
                    <b-nav-item class="nav-link" href="#reality">Reality</b-nav-item>
                    <b-nav-item class="nav-link" href="#sluzby">Služby</b-nav-item>
                    <b-nav-item class="nav-link" href="#onas">O nás</b-nav-item>
                    <b-nav-item class="nav-link" href="#kontakt">Kontakt</b-nav-item>
                </b-navbar-nav>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>

    <div class="container-fluid" ref="content">

        <!-- Start: Home -->
        <div id="home" class="jumbotron row" style="padding: 13vh 0 0 !important;">            
            <div class="text-wrapper text-wrapper_orange text-wrapper_left">
                <h1 class="headline">MISTAV-CL, s. r. o., je&nbsp;stabilní, dynamicky&nbsp;se rozvíjející firmou v&nbsp;oblasti stavebnictví, již&nbsp;od&nbsp;roku 1999.</h1>
                <h2>V březnu roku 2024 oslaví naše společnost 25 let působení na trhu !</h2>
            </div>
            <div class="text-wrapper text-wrapper_orange text-wrapper_left d-none d-sm-block">
                <p>Každodenní kvalitní a poctivá práce zaměstnanců, vedoucí ke spokojenosti všech zákazníků.</p>
                <p>Dodržování smluvních termínů.</p>
                <p>Zajišťování odborného růstu našich pracovníků.</p>
                <p>Dodržování bezpečnosti práce na stavbách.</p>
                <p>Nabízení služeb v oblasti financování staveb (např. splátkové kalendáře, zajištění úvěru&nbsp;atd.)</p>
            </div>
            <div class="row text-wrapper_orange" style="padding-left: 30px; padding-right: 30px; padding-top: 20px; padding-bottom: 20px;">
                <div class="w-100" style="text-align: center;">
                    <h2>Volné pozice</h2>
                </div>
                
            <!--<div class="col-md-4">
                <h4>Přípravář/ka staveb</h4>
                    Náplň práce: 
                    <ul>
                    <li>technická a výrobní příprava stavby v souladu s PD, rozpočtem, harmonogramem a smlouvou o dílo</li>
                    <li>sestavení a vedení dodavatelského systému stavby</li>
                    <li>kontrola a revize nákladů stavby, evidování víceprací/méněprací</li>
                    <li>spolupráce se stavbyvedoucím, aktivní účast na kontrolních dnech staveb</li>
                    </ul>
                    Požadujeme: 
                    <ul>
                    <li>SŠ či VŠ stavebního směru, praxe v oboru </li>
                    <li>řidičský průkaz sk. B, znalost MS office</li>
                    <li>orientace v projektové dokumentaci a v technických normách</li>
                    <li>orientace ve výkazech výměr a rozpočtech ( stavební software KROS )</li>
                    <li>komunikační schopnost slovem i písmem</li>
                    <li>aktivní přístup, časovou flexibilitu, analytické myšlení</li>
                    <li>orientace v související legislativě výhodou</li>
                    <li>znalost problematiky smluv výhodou</li>
                    </ul>
                    Nabízíme: 
                    <ul>
                    <li>práce na plný úvazek</li>
                    <li>dovolená 4-5 týdnů (dle dohody)</li>
                    <li>stravenky</li>
                    <li>pracoviště v sídle společnosti v České Lípě</li>
                    </ul> 
                    <b>Práce vhodná i pro OZP</b><br>
                    Nástup možný IHNED!<br>
                    Plat:&nbsp;&nbsp;&nbsp;
                    <span style="font-size: 20px;"><b>30 000 - 40 000,- Kč dle praxe</b></span> 
            </div>-->
            <div class="col-md-4">
                <h4>Obchodní zástupce/kyně
                </h4>
                    Náplň práce: 
                    <ul>
                    <li>akvizice nových zakázek</li>
                    <li>sledování a zúčastňování výběrových řízení veřejných zakázek</li>
                    <li>spolupráce se stavbyvedoucím, aktivní účast na kontrolních dnech staveb</li>
                    </ul>
                    Požadujeme: 
                    <ul>
                    <li>SŠ či VŠ</li>
                    <li>základní znalost stavebnictví</li>
                    <li>řidičský průkaz sk. B, znalost MS office</li>
                    <li>orientace v projektové dokumentaci a v technických normách</li>
                    <li>komunikační schopnost slovem i písmem</li>
                    <li>aktivní přístup, časovou flexibilitu, analytické myšlení</li>
                    <li>orientace v související legislativě výhodou</li>
                    <li>znalost problematiky smluv výhodou</li>
                    </ul>
                    Nabízíme: 
                    <ul>
                    <li>práce na plný úvazek</li>
                    <li>dovolená 4-5 týdnů (dle dohody)</li>
                    <li>stravenky</li>
                    <li>pracoviště v sídle společnosti v České Lípě</li>
                    </ul> 
                    Nástup možný IHNED!<br>
                    Plat:&nbsp;&nbsp;&nbsp;
                    <span style="font-size: 20px;"><b>30 000 - 40 000,- Kč dle výkonu</b></span> 
            </div>
            <div class="col-md-4">
                <h4>Rozpočtář/ka staveb</h4>
                    Požadujeme: 
                    <ul>
                    <li>praxi s tvorbou rozpočtů staveb</li>
                    <li>výbornou orientaci ve výkresech a projektové dokumentaci </li>
                    <li>spolehlivost </li>
                    <li>výbornou znalost programů WORD, EXCEL, RTS, ÚRS</li>
                    <li>řidičský průkaz sk. B</li>
                    <li>zkušenosti s veřejnými zakázkami a dotačními programy</li>
                    <li>10 let praxe ve stavebnictví výhodou</li>
                    </ul>
                    Nabízíme: 
                    <ul>
                    <li>práce na plný úvazek</li>
                    <li>dovolená 4-5 týdnů (dle dohody) </li>
                    <li>stravenky </li>
                    <li>možnost ubytování </li>
                    <li>pracovní doba od 7:00 do 15:00</li>
                    <!--<li><span style="font-size: 18px;"><b>NÁSTUPNÍ BONUS VE VÝŠI 50 000,- Kč</b></span></li>-->
                    </ul>    
                    Nástup možný IHNED!<br>
                    Plat:&nbsp;&nbsp;&nbsp;
                    <span style="font-size: 20px;"><b>30 000 - 40 000,- Kč dle praxe</b></span>
                </div>
                <div class="col-md-4">
                <h4>Stavbyvedoucí</h4>
                    Požadujeme: 
                    <ul>
                    <li>praxi v oboru min 5 let</li>
                    <li>výbornou orientaci ve výkresech a projektové dokumentaci </li>
                    <li>spolehlivost </li>
                    <li>zkušenosti s vedením týmu</li>
                    <li>řidičský průkaz sk. B</li>
                    </ul>
                    Nabízíme: 
                    <ul>
                    <li>práce na plný úvazek</li>
                    <li>dovolená 4-5 týdnů (dle dohody) </li>
                    <li>stravenky </li>
                    <li>možnost ubytování </li>
                    <li>pracovní doba od 7:00 do 15:00</li>
                    <!--<li><span style="font-size: 18px;"><b>NÁSTUPNÍ BONUS VE VÝŠI 50 000,- Kč</b></span></li>-->
                    </ul>    
                    Nástup možný IHNED!<br>
                    Plat:&nbsp;&nbsp;&nbsp;
                    <span style="font-size: 20px;"><b>30 000,- - 50 000,- Kč</b></span>
                </div> 
            </div><br>
            <div class="text-wrapper text-wrapper_orange text-wrapper_left d-none d-sm-block">
                <h2>Další volné pozice</h2>
               <span style="font-size:20px;"> 
               <ul>
                    <li>Zedník - plat 25 000,- - 30 000,- + stravenky<br>Praxe min. 2 roky</li>
                    <!--<li>Vodoinstalatér</li>
                    <li>Topenář</li>
                    <li>Obkladač</li>
                    <li>Sádrokartonář</li>
                    <li>Rozpočtář/ka</li>-->

                </ul>    
                <p>Nástup možný ihned nebo po dohodě!<br>Pro více informací pište na email stavby@mistavcl.cz.</p></span>
            </div>
                
        </div>
        <section id="section07" class="scroll-btn demo">
            <a @click="scrollMeTo('stavby')"><span></span><span></span><span></span></a>
        </section>
        <!-- End: Home -->
        <!-- <div class="container">
        <div class="row">
            <div class="col-md-4">
            <h2>Heading</h2>
            <p>Donec id elit non mi porta gravida at eget metus. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod. Donec sed odio dui. </p>
            <p><a class="btn btn-secondary" href="#" role="button">View details &raquo;</a></p>
            </div>
            <div class="col-md-4">
            <h2>Heading</h2>
            <p>Donec id elit non mi porta gravida at eget metus. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod. Donec sed odio dui. </p>
            <p><a class="btn btn-secondary" href="#" role="button">View details &raquo;</a></p>
            </div>
            <div class="col-md-4">
            <h2>Heading</h2>
            <p>Donec sed odio dui. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Vestibulum id ligula porta felis euismod semper. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.</p>
            <p><a class="btn btn-secondary" href="#" role="button">View details &raquo;</a></p>
            </div>
        </div> -->

        <!-- Start: Stavby -->
        <div class="row" id="stavby" ref="stavby">
            <h1 class="headline-category">Stavební činnost</h1>

            <b-carousel id="carousel1"
                            style="text-shadow: 1px 1px 2px #333; width: 100%; overflow: hidden;"
                            controls
                            indicators
                            background="#ababab"
                            :interval="14000"
                            img-width="1920"
                            img-height="800"
                            v-model="slide1"
                            @sliding-start="onSlideStart"
                            @sliding-end="onSlideEnd"
                >

                <b-carousel-slide caption="Hotely"
                                    :img-src="require('./assets/reference/Hotel-Morris-Ceska-Lipa.jpg')">
                    <ul>
                        • Hotel Morris Mariánské Lázně<br/>
                        • Hotel Morris Česká Lípa
                    </ul>
                    <b-button @click="showHotels" class="btn-gallery">Galerie</b-button>
                </b-carousel-slide>

                <b-carousel-slide caption="Benzínové pumpy"
                                    :img-src="require('./assets/reference/KMProna-MnHradiste.jpg')">
                    <ul>
                        <li>• KM Prona - Mnichovo Hradiště</li>
                        <li>• KM Prona – Nový Bor</li>
                        <li>• KM Prona – Budyně nad Ohří</li>
                        <li>• KM Prona – Městec </li>
                        <li>• KM Prona – Praha-Hostivař</li>
                        <li>• KM Prona – Česká Lípa-Stará Lípa</li>
                    </ul>
                    <b-button @click="showGasStations" class="btn-gallery">Galerie</b-button>
                </b-carousel-slide>

                <b-carousel-slide caption="Rekonstrukce"
                    :img-src="require('./assets/reference/VillaHrdlicka.jpg')"
                >
                    <ul>
                        <li>• Kulturní dům – Nový Oldřichov</li>
                        <li>• Glass shop Crystalex – Nový Bor</li>
                        <li>• Restaurace u Kerama – Žizníkov</li>
                        <li>• Villa Hrdlička – Děčínská, Česká Lípa</li>
                        <li>• Centrum zdraví NSP – Česká Lípa</li>
                        <li>• Bytový dům – Mimoň</li>
                        <li>• Lineta (bytový dům + kavárna Reunion) – Česká Lípa</li>
                        <li>• Kulturní dům - Mařenice</li>
                        <li>• Bytový dům Jiráskova 34 - Česká Lípa</li>
                        <li>• Restaurace u Slunce – Skalice u České Lípy</li>
                        
                    </ul>
                    <b-button @click="showReconstructions" class="btn-gallery">Galerie</b-button>
                </b-carousel-slide>

                <b-carousel-slide caption="Fasády"
                    :img-src="require('./assets/reference/ZsSlovanka.jpg')"
                >
                    <ul>
                        <li>• Festool Vila – Moskevská, Česká Lípa</li>
                        <li>• Kavárna Union – Česká Lípa</li>
                        <li>• Poliklinika NSP – Česká Lípa</li>
                        <li>• Základní škola Slovanka – Česká Lípa</li>
                        <li>• Panelový dům – Sadová, Nový Bor</li>
                        <li>• Střední průmyslová škola – Česká Lípa - 1. část</li>
                        <li>• Střední průmyslová škola – Česká Lípa - 2. část</li>
                        <li>• Základní škola –Nový Oldřichov</li>
                        <li>• Panelový dům – OSBD Východní, Česká Lípa</li>
                        <li>• DIAMO, statní podnik o.z. Těžba a úprava uranu – Hala odsolení SLKR I – Stráž pod Ralskem</li>
                        <li>• Kooperativa – Česká Lípa</li>
                    </ul>
                    <b-button @click="showFacades" class="btn-gallery">Galerie</b-button>
                </b-carousel-slide>

                <b-carousel-slide caption="Novostavby"
                    :img-src="require('./assets/reference/RD_LIBCHAVA-Novak.jpg')"
                >
                    <ul>
                        <li>• Golf Resort – Česká Lípa </li>
                        <li>• Rodinný dům – Skalice u České Lípy</li>
                        <li>• Rodinný dům – Horní Libchava </li>
                        <li>• Rodinný dům – Praha-Hostivice </li>
                        <li>• Rodinný dům – Cvikov </li>
                        <li>• Rodinný dům – Česká Lípa (pod vysílačem Špičák)</li>
                        <li>• Rodinný dům – Krompach </li>
                        <li>• Rodinný dům – Jestřebí </li>
                        <li>• Bytový dům – Ploužnice </li>
                        <li>• Základní škola Tyršova – šatny, Česká Lípa</li>
                        <li>• Základní škola Jižní – Česká Lípa</li>
                        <li>• Přístavba Základní školy ve Skalici u České Lípy</li>
                        <li>• Nová základna Báňské záchranné služby v areálu DIAMO</li>
                    </ul>
                    <b-button @click="showNewBuildings" class="btn-gallery">Galerie</b-button>
                </b-carousel-slide>

                <b-carousel-slide caption="Průmysl"
                    :img-src="require('./assets/reference/Sauer.jpg')"
                >
                    <ul>
                        <li>• Sauer, vestavba haly – Žandov</li>
                        <li>• Sauer, nová hala – Žandov</li>
                        <li>• Festool, přístavba haly – Česká Lípa</li>
                        <li>• Festool, koridor – Česká Lípa</li>
                        <li>• Hangár- letiště, Česká Lípa</li>
                        <li>• Festool - rekonstrukce průmyslových hal - Česká Lípa</li>
                        <li>• Fehrer - zděné konstrukce - Česká Lípa </li>
                    </ul>
                    <b-button @click="showFactories" class="btn-gallery">Galerie</b-button>
                </b-carousel-slide>
            </b-carousel>
        </div>
        <!-- End: Stavby -->

<!-- Start: AktualniStavby -->
        <!--<div class="row" id="aktualnistavby" ref="aktualnistavby">
            <h1 class="headline-category">Významné dokončené stavby</h1>

            <b-carousel id="carousel1111"
                            style="text-shadow: 1px 1px 2px #333;    width: 100%;
                                overflow: hidden;"
                            controls
                            indicators
                            background="#ababab"
                            :interval="14000"
                            img-width="1920"
                            img-height="800"
                            v-model="slide1"
                            @sliding-start="onSlideStart"
                            @sliding-end="onSlideEnd"
                >

                <b-carousel-slide caption="Přístavba ZŠ Skalice u České Lípy"
                                    :img-src="require('./assets/reference/ZsSkalice/skalice28.jpg')">
                                    <ul>
                        <li><b>Stavba byla dokončena za 8 měsíců !</b></li>
                    </ul>
                    <b-button @click="showzsskalice" class="btn-gallery">Galerie</b-button>
                </b-carousel-slide>

               <b-carousel-slide caption="Rekonstrukce - Infocentrum Česká Lípa"
                                    :img-src="require('./assets/reference/infocentrum/infocentrum.jpg')">
                    <b-button @click="showinfocentrum" class="btn-gallery">Galerie</b-button>
                </b-carousel-slide>

                <b-carousel-slide caption="Fasády"
                    :img-src="require('./assets/reference/ZsSlovanka.jpg')"
                >
                    <ul>
                        <li>• Festool Vila – Moskevská, Česká Lípa</li>
                        <li>• Budova Unionka – Česká Lípa</li>
                        <li>• Poliklinika NSP – Česká Lípa</li>
                        <li>• Základní škola Slovanka – Česká Lípa</li>
                        <li>• Panelový dům – Sadová, Nový Bor</li>
                        <li>• Střední průmyslová škola – Česká Lípa</li>
                        <li>• Základní škola –Nový Oldřichov</li>
                        <li>• Panelový dům – OSBD Východní, Česká Lípa</li>
                        <li>• DIAMO, statní podnik o.z. Těžba a úprava uranu – Hala odsolení SLKR I – Stráž pod Ralskem</li>
                        <li>• Kooperativa – Česká Lípa</li>
                    </ul>
                    <b-button @click="showFacades" class="btn-gallery">Galerie</b-button>
                </b-carousel-slide>

                <b-carousel-slide caption="Novostavby"
                    :img-src="require('./assets/reference/RD_LIBCHAVA-Novak.jpg')"
                >
                    <ul>
                        <li>• Golf Resort – Česká Lípa </li>
                        <li>• Rodinný dům – Skalice u České Lípy</li>
                        <li>• Rodinný dům – Horní Libchava </li>
                        <li>• Rodinný dům – Praha-Hostivice </li>
                        <li>• Rodinný dům – Cvikov </li>
                        <li>• Základní škola Tyršova – šatny, Česká Lípa</li>
                        <li>• Základní škola Jižní – Česká Lípa</li>
                    </ul>
                    <b-button @click="showNewBuildings" class="btn-gallery">Galerie</b-button>
                </b-carousel-slide>

                <b-carousel-slide caption="Průmysl"
                    :img-src="require('./assets/reference/Sauer.jpg')"
                >
                    <ul>
                        <li>• Sauer, vestavba haly – Žandov</li>
                        <li>• Sauer, nová hala – Žandov</li>
                        <li>• Festool, přístavba haly – Česká Lípa</li>
                        <li>• Hangár- letiště, Česká Lípa</li>
                    </ul>
                    <b-button @click="showFactories" class="btn-gallery">Galerie</b-button>
                </b-carousel-slide>
            </b-carousel>
        </div>-->
        <!-- End: AktualniStavby -->


        <!-- Start: prodej -->            
        <div id="prodej" class="jumbotron row" ref="prodej">
            <h1 class="headline-category">Prodej</h1>
            <div class="container">

                <b-tabs>
                    <!--<b-tab>
                        <template slot="title">
                            <img class="img-fluid" src="./assets/icons/ico-zelezo.svg" />
                            <h2>
                                Železo na míru
                            </h2>
                        </template>
                        <br>Připravuje se
                    </b-tab>-->
                    <b-tab active>
                        <template slot="title">
                            <img class="img-fluid" style="max-width: 100px;" src="./assets/icons/ico-pisek.svg" />
                            <h2>
                                Prodej písku, štěrku,<br/> kameniva
                            </h2>
                        </template>
                        
                        <div class="row material-wrapper">
                        <div class="col-sm-12">
                           <!-- <p class="d-block text-center" style="color:red; font-size: 25px;">
                               <b>PRODEJ POUZE NA IČO (z důvodu vládního nařízení)<br><br>Omlouváme se všem zákazníkům, ale z kapacitních důvodů jsou osobní odběry
                                   možné pouze po předchozí domluvě. <br>Děkujeme za pochopení</b>
                                   <br><br><b>Vážení zákazníci, <br>
                                              chtěli bychom vás informovat, že naše prodejna bude otevřena do středy 16.12.
                                              Znovu pro vás otevřeme v novém roce v pondělí 4.1.2021.<br><br>

                                              Děkujeme všem zákazníkům za přízeň a opět se na vás budeme těšit v novém a určitě lepším roce !
                                            
                            </p>
                            <p>
                            <span style="color: red; font-size: 30px; text-align:center;"><b>Od 22.8.2022 do 23.8.2022<br>DOVOLENÁ<br>DĚKUJEME ZA POCHOPENÍ.</b></span>
                            </p>-->
                            <br>
                            <h3 class="headline d-block text-center">Ceník materiálů</h3>
                        </div>
                        <div class="col-md-6">                          
                            <h4 class="headline">Štěrk</h4>
                            <div class="grid">
                                <div class="grid-row">
                                    <div><b>Frakce</b></div>
                                    <div><b>Cena bez DPH</b></div>
                                    <div><b>Cena s DPH</b></div>
                                </div>
                                <div class="grid-row">
                                    <div>0/32<!-- - <span class="skladem"><b>SKLADEM</b></span>--></div>
                                    <div>495,- Kč</div>
                                    <div>599,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>0/63</div>
                                    <div>495,- Kč</div>
                                    <div>599,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>2/5 ("rýže" - pod zámkovou dlažbu)</div>
                                    <div>578,- Kč</div>
                                    <div>699,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>8/16</div>
                                    <div>558,- Kč</div>
                                    <div>675,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>16/32</div>
                                    <div>558,- Kč</div>
                                    <div>675,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>32/63</div>
                                    <div>517,- Kč</div>
                                    <div>626,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>Lomový kámen</div>
                                    <div>991,- Kč</div>
                                    <div>1 199,- Kč</div>
                                </div>
                            </div>
                            <h4 class="headline">Písek</h4>
                            <div class="grid">
                                <div class="grid-row">
                                    <div><b>Frakce</b></div>
                                    <div><b>Cena bez DPH</b></div>
                                    <div><b>Cena s DPH</b></div>
                                </div>
                                <div class="grid-row">
                                    <div>0/4 (betoňák)</div>
                                    <div>393,- Kč</div>
                                    <div>476,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>0/4 (betoňák)- 2x praný</div>
                                    <div>556,- Kč</div>
                                    <div>673,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>0/4 (malťák)</div>
                                    <div>404,- Kč</div>
                                    <div>489,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>PR 31 (bílý písek)</div>
                                    <div>710,- Kč</div>
                                    <div>859,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>Zásypový písek (netříděný)</div>
                                    <div>340,- Kč</div>
                                    <div>411,- Kč</div>
                                </div>
                            </div><!-- 
                            <h4 class="headline"><span style="color: red;">AKCE !</span> - Mulčovací kůra (cena uvedena za 1 m3)</h4>
                            <div class="grid">
                                <div class="grid-row">
                                    <div><b>Frakce</b></div>
                                    <div><b>Cena bez DPH</b></div>
                                    <div><b>Cena s DPH</b></div>
                                </div>
                                <div class="grid-row">
                                    <div>výběrová 0/80 mm (1t cca 3m3)</div><span class="skladem"><b>SKLADEM</b></span></div>
                                    <div><s>667,- Kč</s><br><span style="color: red;"><b>583,- Kč</b></span></div>
                                    <div><s>807,- Kč</s><br><span style="color: red;"><b>705,- Kč</b></span></div>
                                </div>
                                <div class="grid-row">
                                    <div><b>Cena za 1t je <s>2 000,-</s><br><span style="color: red;"> 1 750,- bez DPH</span></b></div>
                                </div>
                                <br><div class="grid-row">
                                    <div><b>Příklad ceny kůry:</b><br> 100 L cca 80,- Kč vč. DPH</div>
                                </div>
                                <div class="grid-row">
                                    <div><b>Rozvoz mulčovací kůry je možný od 1 m3!</b></div>
                                </div>
                                <div class="grid-row">
                                    <div>Možnost zakoupení pytle 120L na kůru za 24,- Kč vč. DPH</div>
                                </div>
                            </div>-->
                            
                        </div>
                        <div class="col-md-6">
                            <!--<h4 class="headline">Štěrk (čedič)</h4>
                            <div class="grid">
                                <div class="grid-row">
                                    <div><b>Frakce</b></div>
                                    <div><b>Cena bez DPH</b></div>
                                    <div><b>Cena s DPH</b></div>
                                </div>
                                <div class="grid-row">
                                    <div>2/5 ("rýže" - pod zámkovou dlažbu)</div>
                                    <div>506,- Kč</div>
                                    <div>612,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>0/32 - <span class="na-dotaz"><b>NA DOTAZ</b></span></div>
                                    <div>- ,- Kč</div>
                                    <div>- ,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>0/63 - <span class="na-dotaz"><b>NA DOTAZ</b></span></div>
                                    <div>- ,- Kč</div>
                                    <div>- ,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>8/16 - <span class="na-dotaz"><b>NA DOTAZ</b></span></div>
                                    <div>- ,- Kč</div>
                                    <div>- ,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>16/32 - <span class="skladem"><b>SKLADEM</b></span></div>
                                    <div>441,- Kč</div>
                                    <div>534,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>32/63 - <span class="na-dotaz"><b>NA DOTAZ</b></span></div>
                                    <div>- ,- Kč</div>
                                    <div>- ,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>Jednomletka - <span class="na-dotaz"><b>NA DOTAZ</b></span></div>
                                    <div>298,- Kč</div>
                                    <div>360,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>Odval - <span class="na-dotaz"><b>NA DOTAZ</b></span></div>
                                    <div>213,- Kč</div>
                                    <div>258,- Kč</div>
                                </div>
                            </div>
                            <h4 class="headline">Kačírek pranný</h4>
                            <div class="grid">
                                <div class="grid-row">
                                    <div><b>Frakce</b></div>
                                    <div><b>Cena bez DPH</b></div>
                                    <div><b>Cena s DPH</b></div>
                                </div>
                                <div class="grid-row">
                                    <div>4/8</div>
                                    <div>475,- Kč</div>
                                    <div>575,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>11/22</div>
                                    <div>460,- Kč</div>
                                    <div>557,- Kč</div>
                                </div>
                            </div>
                            <h4 class="headline">Recyklát (suť)</h4>
                            <div class="grid">
                                <div class="grid-row">
                                    <div><b>Frakce</b></div>
                                    <div><b>Cena bez DPH</b></div>
                                    <div><b>Cena s DPH</b></div>
                                </div>
                                <div class="grid-row">
                                    <div>Nedrcený - <span class="na-dotaz"><b>NA DOTAZ</b></span></div>
                                    <div>50,- Kč</div>
                                    <div>60,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>Drcený - <span class="skladem"><b>SKLADEM</b></span></div>
                                    <div>100,- Kč</div>
                                    <div>121,- Kč</div>
                                </div>
                            </div>
                            <div class="distribution">
                            <h4 class="headline">Doprava</h4>
                            <h5>Ford Transit - sklopka (do 1,5t)</h5>
                            <div class="grid">
                                <div class="grid-row">
                                    <div></div>
                                    <div><b>Cena bez DPH</b></div>
                                    <div><b>Cena s DPH</b></div>
                                </div>
                                <div class="grid-row">
                                    <div>Do 15km</div>
                                    <div>600,- Kč /km</div>
                                    <div>726,- Kč /km</div>
                                </div>
                                <div class="grid-row">
                                    <div>do 1,5t nad 15km</div>
                                    <div>22,- Kč /km</div>
                                    <div>27,- Kč /km</div>
                                </div> 
                                <div class="grid-row">
                                    <div>nad 1,5t a 15km</div>
                                    <div>37,- Kč /km</div>
                                    <div>45,- Kč /km</div>
                                </div> 
                            </div>
                            </div>-->
                            <h4 class="headline">Kačírek pranný</h4>
                            <div class="grid">
                                <div class="grid-row">
                                    <div><b>Frakce</b></div>
                                    <div><b>Cena bez DPH</b></div>
                                    <div><b>Cena s DPH</b></div>
                                </div>
                                <div class="grid-row">
                                    <div>4/8</div>
                                    <div>669,- Kč</div>
                                    <div>810,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>11/22</div>
                                    <div>664,- Kč</div>
                                    <div>803,- Kč</div>
                                </div>
                            </div>
                            <h4>Galerie materiálů</h4>
                            <!--<b-button @click="showModal2" class="btn-materials">
                                <img class="img-fluid" src="./assets/materialy/pisek0-4-betonak.jpg" />
                            </b-button>-->
                            <b-carousel id="carousel-fade"
                            style="text-shadow: 1px 1px 2px #333; width: 100%; overflow: hidden;"
                            fade
                            controls
                            indicators
                            :interval="4000"
                            img-width="1920"
                            img-height="800"
                            v-model="slide15"
                            @sliding-start="onSlideStart"
                            @sliding-end="onSlideEnd"
                            >
                            <b-carousel-slide caption="Písek 0/4 - betoňák" :img-src="require('./assets/materialy/pisek0-4-betonak.jpg')">
                            </b-carousel-slide>
                            <b-carousel-slide caption="Písek 0/4 - malťák" :img-src="require('./assets/materialy/maltak0-4.jpg')">
                            </b-carousel-slide>
                            <b-carousel-slide caption="Písek 0/4 - betoňák 2x praný" :img-src="require('./assets/materialy/pisek0-4-betonak-prany.jpg')">
                            </b-carousel-slide>
                            <b-carousel-slide caption="Bílý písek PR31" :img-src="require('./assets/materialy/pr31.jpg')" >
                            </b-carousel-slide>
                            <b-carousel-slide caption="PDK 0/32 - znělec" :img-src="require('./assets/materialy/pdk0-32.jpg')" >
                            </b-carousel-slide>
                            <b-carousel-slide caption="PDK 0/63 - znělec" :img-src="require('./assets/materialy/pdk0-63.jpg')" >
                            </b-carousel-slide>
                            <b-carousel-slide caption="PDK 2/5 - čedič" :img-src="require('./assets/materialy/pdk2-5.jpg')" >
                            </b-carousel-slide>
                            <b-carousel-slide caption="PDK 8/16 - znělec" :img-src="require('./assets/materialy/pdk8-16.jpg')" >
                            </b-carousel-slide>
                            <b-carousel-slide caption="PDK 16/32 - čedič" :img-src="require('./assets/materialy/pdk16-32.jpg')" >
                            </b-carousel-slide>
                            <b-carousel-slide caption="PDK 32/63 - znělec" :img-src="require('./assets/materialy/pdk32-63.jpg')" >
                            </b-carousel-slide>
                            <b-carousel-slide caption="Kačírek 4/8 - praný" :img-src="require('./assets/materialy/kacirek4-8-prany.jpg')" >
                            </b-carousel-slide>
                            <b-carousel-slide caption="Kačírek 11/22 - praný" :img-src="require('./assets/materialy/kacirek11-22-prany.jpg')" >
                            </b-carousel-slide>
                            <b-carousel-slide caption="Mulčovací kůra výběrová 0/80mm" :img-src="require('./assets/materialy/mulcovaci-kura0-80.jpg')" >
                            </b-carousel-slide>
                            <b-carousel-slide caption="Lomový kámen" :img-src="require('./assets/materialy/lomovykamen.jpg')" >
                            </b-carousel-slide>
                            </b-carousel>
                        </div>
                    </div>
                    <div class="row material-wrapper">
                        <div class="col-sm-12">
                            <h3 class="headline d-block text-center">Doprava</h3>
                        </div>
                    <div class="col-sm-4">
                    <div class="distribution">
                            <h4 class="headline">Ford Transit - sklopka (do 1,8t - max 1m3)</h4>
                            <div class="grid">
                                <div class="grid-row">
                                    <div></div>
                                    <div><b>Cena bez DPH</b></div>
                                    <div><b>Cena s DPH</b></div>
                                </div>
                                <div class="grid-row">
                                    <div>Do 5 km</div>
                                    <div>271,- Kč</div>
                                    <div>328,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>Do 10 km</div>
                                    <div>371,- Kč</div>
                                    <div>449,- Kč</div>
                                </div> 
                                <div class="grid-row">
                                    <div>Do 15 km</div>
                                    <div>491,- Kč</div>
                                    <div>594,- Kč</div>
                                </div> 
                                <div class="grid-row">
                                    <div>Nad 15 km</div>
                                    <div>19,- Kč /km</div>
                                    <div>23,- Kč /km</div>
                                </div> 
                            </div>
                    </div>
                    </div>
                    <div class="col-sm-4">
                    <div class="distribution">
                            <h4 class="headline">DAF - kontejner (do 6t - max 4m3) </h4>
                            <div class="grid">
                                <div class="grid-row">
                                    <div></div>
                                    <div><b>Cena bez DPH</b></div>
                                    <div><b>Cena s DPH</b></div>
                                </div>
                                <div class="grid-row">
                                    <div>Do 5 km</div>
                                    <div>430,- Kč</div>
                                    <div>520,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>Do 10 km</div>
                                    <div>586,- Kč</div>
                                    <div>709,- Kč</div>
                                </div> 
                                <div class="grid-row">
                                    <div>Do 15 km</div>
                                    <div>779,- Kč</div>
                                    <div>943,- Kč</div>
                                </div> 
                                <div class="grid-row">
                                    <div>Nad 15 km</div>
                                    <div>28,- Kč /km</div>
                                    <div>34,- Kč /km</div>
                                </div>  
                            </div>
                    </div>
                    </div>
                    <div class="col-sm-4">
                    <div class="distribution">
                            <h4 class="headline">MERCEDES-BENZ - sklopka (do 12t - max 7m3)</h4>
                            <div class="grid">
                                <div class="grid-row">
                                    <div></div>
                                    <div><b>Cena bez DPH</b></div>
                                    <div><b>Cena s DPH</b></div>
                                </div>
                                <div class="grid-row">
                                    <div>Do 5 km</div>
                                    <div>497,- Kč</div>
                                    <div>601,- Kč</div>
                                </div>
                                <div class="grid-row">
                                    <div>Do 10 km</div>
                                    <div>755,- Kč</div>
                                    <div>913,- Kč</div>
                                </div> 
                                <div class="grid-row">
                                    <div>Do 15 km</div>
                                    <div>1 063,- Kč</div>
                                    <div>1 286,- Kč</div>
                                </div> 
                                <div class="grid-row">
                                    <div>Nad 15 km</div>
                                    <div>37,- Kč /km</div>
                                    <div>45,- Kč /km</div>
                                </div>  
                            </div>
                    </div>
                    </div>
                    </div>
                    <hr />
                    <p class="d-block w100">
                    <!--span style="color: red; font-size: 30px;"><b>Od 11.9.2020 (pátek) do 14.9.2020 <br>DOVOLENÁ<br>DĚKUJEME ZA POCHOPENÍ.</b></span><br><br>-->
                    Ceny materiálů jsou uvedeny za 1 tunu. Pro aktuální informace nás <a href="#kontakt">kontaktujte</a><br>
                    <span style="font-size: 20px;"><b>Nakládka a manipulace - 97,- Kč vč. DPH (platí při nakládce naším zaměstnancem na prodejně)</b></span><br>
                    <span style="font-size: 20px;"><b>Nakládka, vykládka a manipulace - 182,- Kč vč. DPH (platí při rozvozu)</b></span><br></br>
                    <span style="font-size: 20px;">Objednávky či dotazy zasílejte na <b>prodej@mistavcl.cz</b> nebo volejte na<b> +420 725 814 755</b></span><br><br><br>
                    <span style="font-size: 20px;">Najdete nás také na Facebooku, kam dáváme aktuální informace.<br>
                    Tak nám nezapomeňte dát <b>"To se mi líbí"</b>, ať máte vždy aktuální informace!<br></span>
                    <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fsypkematerialyceskalipa%2F&tabs=timeline&width=500&height=300&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="500" height="300" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
                    <br><br>
                    <img class="d-block w100" src="./assets/IMG-6907.jpg" width="100%" />
                    <br><b><i>Provozovatelem a prodejcem je dceřiná společnost STAVMI-CZ s.r.o., IČO: 28741161 DIČ: CZ28741161</i></b>
                    </p>
                    </b-tab>
                    <!--
                    <b-tab>
                        <template slot="title">
                            <img class="img-fluid" src="./assets/icons/ico-hutni.svg" />
                            <h2>
                                Prodej hutního materiálu
                            </h2>
                            <img class="img-fluid" src="./assets/icons/trminky-logo.png" />
                            <h2>
                                Výroba třmínků
                            </h2>
                        </template>
                        <br>
                        <p>
                        <span style="font-size:25px;"><b>Potřebujete vyrobit třmínky do věnce pro vaší stavbu ?</b></span><br><br>
                        <span style="font-size:22px;">Zašlete nám poptávku na email nebo telefonicky s rozměry, počtem kusů a my Vám vypracujeme nabídku na míru.<br>
                        Vyrábíme třmínky z betonářských ocelových tyčí o průměrech<b> 6, 8, 10, 12 mm</b></span>. 
                        </p><br>
                        
                    <p class="d-block w100">
                            <span style="font-size:20px;">Objednávky a poptávky zasílejte na email <b>prodej@mistavcl.cz</b> nebo volejte na <b>+420 725 814 755</b></span><br><br>
                            <b><i>Provozovatelem a prodejcem je dceřiná společnost STAVMI-CZ s.r.o., IČO: 28741161 DIČ: CZ28741161</i></b>
                            </p>
                    </b-tab>
                    <b-tab>
                        <template slot="title">
                            <img class="img-fluid" src="./assets/icons/ico-hutni.svg" />
                            <h2>
                                Prodej hutního materiálu
                            </h2>
                            <img class="img-fluid" style="margin-top: 7%; max-width: 100px;" src="./assets/icons/logo-zemni-prace.png" />
                            <h2>
                                Zemní práce
                            </h2>
                        </template>
                        <br>
                        <p>
                        <span style="font-size:22px;">Provádíme zemní a výkopové práce od výkopů základových pasů po finální terenní úpravy.</span> 
                        </p>
                        <div class="row material-wrapper">
                        <div class="col-sm-12">
                            <h3 class="headline d-block text-center">Ceník</h3>
                        </div>
                    <div class="col-sm-4">
                    <div class="distribution">
                            <h4 class="headline">CAT 289 D</h4>
                            <img style="max-width: 100%;" src="./assets/icons/cat-289-d.jpg" /><br><br>
                            <p>
                                <b>pásový smykový nakladač 5,5t</b><br><br>
                                nakládací lopata o objemu 0,440m3<br>
                                manipulační vidle nosnost 1,8t<br><br>
                                Cena za hod <b>950,- Kč bez DPH</b><br><br>
                                Přesun do 20 km - <b>hodinová sazba</b><br>
                                Přesun nad 20 km - <b>35,- Kč bez DPH / km </b>
                            </p> 
                    </div>
                    </div>
                    <div class="col-sm-4">
                    <div class="distribution">
                            <h4 class="headline">CAT 303 CR</h4>
                            <img style="max-width: 100%;" src="./assets/icons/cat-303-cr.jpg" /><br><br>
                            <p>
                                <b>pásové rypadlo 3,2t </b><br><br>
                                podkopové lopaty š. 30, 50, 65cm<br>
                                svahovka š. 1,2m<br><br>
                                Cena za hod <b>950,- Kč bez DPH</b><br>
                                S bouracím kladivem cena za hod <b>1 150,- Kč bez DPH</b><br>
                                nebo cena za <b>1m3</b> - betonu prostého <b>1 700,- bez DPH</b><br>
                                cena za <b>1m3</b> - železobetonu <b> 2 200,- Kč bez DPH</b><br><br>
                                Přesun do 20 km - <b>hodinová sazba</b><br>
                                Přesun nad 20 km - <b>35,- Kč bez DPH / km </b>
                            </p>
                    </div>
                    </div>
                    <div class="col-sm-4">
                    <div class="distribution">
                            <h4 class="headline">CAT 314 C LCR</h4>
                            <img style="max-width: 100%;" src="./assets/icons/cat-314-c-lcr.jpg" /><br><br>
                            <p>
                                <b>pásový rypadlo 15,8t</b><br><br>
                                podkopové lopaty š. 70, 100cm<br>
                                svahovka š. 1,6m<br><br>
                                Cena za hod <b>1 500,- Kč bez DPH</b><br>
                                při dlouhodobém nasazení cena za hod <b>1 400,- Kč bez DPH</b><br><br>
                                Přesun - <b>75,- Kč bez DPH / km </b>
                            </p>
                    </div>
                    </div>
                    </div><br><br>
                    <p class="d-block w100">
                            <span style="font-size:20px;">Objednávky a poptávky zasílejte na email <b>prodej@mistavcl.cz</b> nebo volejte na <b>+420 725 814 755</b></span><br><br>
                            <b><i>Provozovatelem je dceřiná společnost STAVMI-CZ s.r.o., IČO: 28741161 DIČ: CZ28741161</i></b>
                            </p>
                    </b-tab>-->
                </b-tabs>

                
            </div>
        </div>
        <!-- End: prodej -->

        <!-- Start: Reality -->
        <div class="row" id="reality">
            <h1 class="headline-category">Reality</h1>
            <div class="jumbotron cover">
                <div class="text-wrapper text-wrapper_left text-wrapper_gray">
                    <h3 class="headline">Reality</h3>
                </div>
                <div class="text-wrapper text-wrapper_left text-wrapper_white">
                    <ul>
                        <li>reality</li>
                        <li>pozemky</li>
                        <li>developerské projekty</li>
                        <li><a href="#kontakt">Kontakt</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-md-4 col-sm-12 item-box">
                <img src="./assets/tovarni2.jpg" class="img-fluid" />
                <h2>Stavební pozemek vč. projektu a vyřízeným stavebním povolením</h2>
                <p>Nabízíme vám rovinatý pozemek o ploše 3 838 m² s projektem a stavebním povolením pro výstavbu ubytovacího a bytového zařízení. Pozemek leží na okraji průmyslové zóny v České Lípě v blízkosti velkých výrobních firem.
                   Navržený objekt je obdélníkového půdorysu o rozměrech 40 x 13,3 m, nepodsklepený, o třech nadzemních podlažích o výšce 10,2 m v nejvyšším bodě. 
                   Je projektován pro 24 ubytovacích jednotek 1+kk s vlastním sociálním zařízením a 8 bytových jednotek 1+1. Vytápění objektu plynovými kotli.<br><br>
                   Více info na a.michlik@mistavcl.cz
                </p>
            </div>
            <!--<div class="col-md-4 col-sm-12 item-box">
                <img src="https://fakeimg.pl/640x380/?text=foto" class="img-fluid" />
                <h2>Nemovitost</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam non commodo elit. Suspendisse potenti. Morbi accumsan lacinia elit, sed pharetra arcu interdum a. kontakt: <a href="#kontakt">kontakt</a></p>
            </div>-->
        </div>
        <!-- End: Reality -->

        <!-- Start: Služby -->
        <div class="row" id="sluzby">
            <h1 class="headline-category">Ostatní služby</h1>
            <div class="col-md-4 offset-md-2">
                <img class="img-fluid" src="./assets/icons/ico-inspekce.svg" />
                <h3 class="headline">Provádíme inspekci vašich trubek, odpadů, kanalizací a&nbsp;komínů pomocí kamerového systému značky SUNDA s dosahem 50m a&nbsp;průměrem kamery 23mm.</h3>
            </div>
            <div class="col-md-4">
                <img class="img-fluid autovaha" src="./assets/icons/autovaha.jpg" height="244px" alt="vážení vozidel"/>
                <h3 class="headline">Provádíme vážení vozidel na naší automobilové váze o rozměrech 9x3m a váživostí 30t. Při vážení se vydává jako doklad vážní lístek, který slouží zároveň jako daňový doklad.<br><br> <b>Cena zvážení vozidla: 165,- Kč bez DPH.</b></h3>
            </div>
        </div>
        <!-- End: Služby -->

        <!-- Start: o nás -->
        <div class="row gray-background" id="onas">
            <h1 class="headline-category">O nás</h1>
            
            <div class="col-md-12">
                <div class="row">
                    <div class="col-lg-5 offset-lg-1">
                        <h2 class="headline headline_big">MISTAV-CL, s. r. o., je&nbsp;stabilní, dynamicky&nbsp;se rozvíjející firmou v&nbsp;oblasti stavebnictví, již&nbsp;od&nbsp;roku&nbsp;1999.</h2>
                        <h4 class="headline">
                            Politika kvality a environmentální politika
                        </h4>
                        <p>
                            Hlavní prioritou společnosti MISTAV – CL, s.&nbsp;r.&nbsp;o., je uspokojování potřeb zákazníků v&nbsp;požadovaných termínech a&nbsp;v&nbsp;požadované kvalitě výrobků a&nbsp;služeb při&nbsp;optimálních nákladech společnosti. Klademe důraz na&nbsp;postupy, které jsou šetrné z&nbsp;hlediska dopadu činnosti firmy a&nbsp;námi dodávaných produktů na&nbsp;životní prostředí. Plnění těchto zásad spolu s&nbsp;udržením stávajícího rozsahu trhu a&nbsp;jeho rozšiřování zajistí ekonomický růst a&nbsp;prosperitu společnosti, a&nbsp;tím i&nbsp;spokojenost zaměstnanců společnosti. 
                        
                        </p>
                    </div>
                    <div class="col-lg-6">
                        <img class="img-fluid" src="./assets/reference/Sauer.jpg" />
                    </div>
                </div>

                <!-- <div class="row">
                    <div class="col-md-12">
                        <h5 class="headline" style="margin-top: 40px;">K naplnění této politiky přijala společnost následující závazky:</h5>
                    </div>
                    <div class="col-md-6">
                        <ul>
                            <li>Zákazník musí mít důvěru ve stabilní kvalitu našich služeb.</li>
                            <li>Ve všech fázích realizace zakázky uplatňujeme prevenci vad před jejich odstraňováním.</li>
                            <li>Optimálních výsledků dosahujeme výchovou, přípravou a motivací všech pracovníků. Výběr nových zaměstnanců provádíme podle kvalifikace a odborných schopností, znalostí a praktických zkušeností. Aktivně zapojujeme naše pracovníky do ochrany ŽP.</li>
                            <li>Kvalita námi prováděných činností a poskytovaných služeb má v naší společnosti hlavní a nejvyšší prioritu. Kvalita našich služeb je rozhodujícím faktorem ovlivňujícím spokojenost zákazníků a vytváření dobrého jména společnosti. Z uvedených důvodů kvalitu ve společnosti trvale sledujeme, hodnotíme a dokumentujeme.</li>
                            <li>Zavazujeme se při veškeré naší činnosti dodržovat zákonné předpisy a relevantní normy.</li>
                            <li>Zavazujeme se k permanentnímu zlepšování našeho environmentálního profilu a k prevenci znečišťování.</li>
                        </ul>
                    </div>
                    <div class="col-md-6">
                        <ul>
                            <li>Zavazujeme se vytvořit a udržovat postupy k identifikaci, plánování a řízení environmentálních aspektů a hodnocení rizik při všech našich činnostech a u nabízených produktů a služeb s cílem minimalizovat dopady naší činnosti na životní prostředí a na bezpečnostní rizika pro pracovníky a okolí.</li>
                            <li>Zavazujeme se k šetrnému zacházení s přírodními zdroji, a to zejména při používání materiálů a energií a při nakládání s vodami a odpady. Z tohoto hlediska budou procesy, které mají vliv na životní prostředí, analyzovány a zlepšovány.</li>
                            <li>Zavazujeme se pravidelně prověřovat a vyhodnocovat svůj systém managementu kvality a environmentálního managementu. K tomuto účelu stanovujeme prověřitelné cíle, kompetence a zdroje.</li>
                            <li>Zavazujeme se k neustálému zvyšování odborné úrovně a profesionality našich služeb zaváděním nových, vůči životnímu prostředí šetrných technologií, zvyšování kvalifikace našich zaměstnanců a rozšiřování jejich poznatků o dopadech našich činností na životní prostředí a na ochranu zdraví a bezpečnost při práci.</li>
                            <li>Zavazujeme se k plnění požadavků normy, trvalému zlepšování a zvyšování efektivnosti celého systému managementu kvality a životního prostředí.</li>
                        </ul>
                    </div>
                </div>             -->
            </div>

            <div class="col-sm-12 history-wrapper">
                <h3 class="headline row">
                    Historie a současnost
                </h3>
                <div class="row">
                
                <div class="col-md-10 offset-md-1 three-columns-text">
                    <p>
                    Stavební firma MISTAV byla založena v&nbsp;roce 1999 zapsáním na&nbsp;Okresním živnostenském úřadě v&nbsp;České&nbsp;Lípě.
                    V&nbsp;roce 2004 prošla firma transformací z&nbsp;fyzické osoby na&nbsp;právní subjekt “MISTAV-CL&nbsp;s.r.o.” a&nbsp;byla zapsána u&nbsp;Krajského soudu v&nbsp;Ústí&nbsp;nad&nbsp;Labem oddíl&nbsp;C, vložka 20337.
                    Od&nbsp;roku 2008 je firma držitelem certifikátu řízení kvality ISO 9001:2009 v oboru provádění staveb, jejich změn a&nbsp;odstraňování.
                    V&nbsp;roce 2009 firma získala certifikát ISO 14001:2005 environmentálního managementu a&nbsp;ocenění Fasády roku 2008 za rekonstrukci fasády kavárny UNION v&nbsp;České&nbsp;Lípě.
                    V současné době firma zaměstnává cca 80&nbsp;kmenových zaměstnanců a&nbsp;dbá na&nbsp;řádné proškolování a&nbsp;zvyšování kvalifikace svých pracovníků.
                    Spolupracujeme s&nbsp;renomovanými dodavateli stavebních materiálů a&nbsp;pečlivě vybíráme subdodavatele řemeslných prací. Firma MISTAV-CL,&nbsp;s.&nbsp;r.&nbsp;o. je pojištěna vůči škodám a&nbsp;majetku, vzniklým při&nbsp;provádění stavebních prací do&nbsp;výše 50&nbsp;miliónů&nbsp;Kč. Na&nbsp;přání zákazníka lze pojistit zakázku individuálně do&nbsp;potřebné výše dle&nbsp;dohody.
                    </p>
                </div>
                
                </div>
                
            </div>
            <div class="col-sm-12 history-wrapper">
                <h3 class="headline row">
                    Napsali o nás
                </h3>
                <div class="row">
                
                <div class="col-md-10 offset-md-1 three-columns-text">
                    <a href="../dokumenty/diamo.pdf" target="_blank"><img src="../dist/diamo-clanek.jpg" id="diamo-obr"></a>
                </div>
                
                </div>
                
            </div>
        </div>
        <!-- End: o nás -->

        <!-- Start: Kontakt -->
        <div class="row" id="kontakt">
            <h1 class="headline-category">Kontakty</h1>
            <div class="col-md-5 offset-md-1 kontakt-info">
                <h3>MISTAV-CL, s. r. o.</h3>

                <h4>Adresa</h4>
                <p>Sídlo společnosti: Dubice 29, 470 01 Česká Lípa</p>
                <p>Pracovní doba: Po – Pá 7:00 – 15:30</p>
                <p>Prodejní doba: <br>Po – Čt 7:30 – 16:00<br> Pá 7:30 - 15:00</p>

                <h4>Fax a telefon</h4>
                <p><font-awesome-icon icon="phone"></font-awesome-icon> +420 733 534 496 – sekretariát</p>
                <p><font-awesome-icon icon="phone"></font-awesome-icon> +420 725 814 755 – prodej</p>

                <h4>Email</h4>
                <p><font-awesome-icon icon="envelope"></font-awesome-icon> <a href="mailto:stavby@mistavcl.cz">stavby@mistavcl.cz</a></p>
                <p><font-awesome-icon icon="envelope"></font-awesome-icon> <a href="mailto:prodej@mistavcl.cz">prodej@mistavcl.cz</a></p>
                <p><font-awesome-icon icon="envelope"></font-awesome-icon> <a href="mailto:reality@mistavcl.cz">reality@mistavcl.cz</a></p>

                <h4>Obchodní detaily</h4>
                <p>Registrace: OR vedený Krajským soudem v Ústí nad Labem oddíl C., vložka 20337</p>
                <p>Statutární orgán: Aleš Michlík – jednatel společnosti</p>
                <p>Právní forma: společnost s ručením omezeným</p>
                <p>Bankovní spojení: Československá obchodní banka, a. s.</p>
                <p>Číslo účtu: 277353589/0300</p>
                <p>IČ: 25485024</p>
                <p>DIČ: CZ25485024</p>
                <br>
                <span style="font-size: 20px;">Najdete nás také na Facebooku, kam dáváme aktuální informace.<br>
                    Tak nám nezapomeňte dát <b>"To se mi líbí"</b>, ať máte vždy aktuální informace!<br></span>
                <br><iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fmistavcl%2F&tabs=timeline&width=500&height=300&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="500" height="300" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
            </div>
            
            <div class="col-md-6">
                <img class="img-fluid" src="./assets/reference/sidlo.jpg" />
            </div>
            <div class="d-block w-100">
                <div class="map-wrapper">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2528.6927778606664!2d14.502429915739306!3d50.66996447950627!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47096ec0eb3a10c7%3A0x7ddb20a48c561fda!2zRHViaWNlIDI5LCA0NzAgMDEgxIxlc2vDoSBMw61wYQ!5e0!3m2!1sen!2scz!4v1540360654254" width="100%" height="300" frameborder="0" style="border:0" allowfullscreen></iframe>
                </div>
            </div>

            <h1 class="headline-category">Personální kontakty</h1>
            
            <div class="contacts-wrapper">

                <div class="col-lg-3 col-sm-6 contact-box">
                    <h3>Aleš Michlík – jednatel</h3>
                    <p>
                        mobil: 737 245 688<br/>
                        e-mail: a.michlik@mistavcl.cz
                    </p>
                </div>
                <!--<div class="col-lg-3 col-sm-6 contact-box">
                    <h3>Jana Jiránková – obchodní ředitelka</h3>
                    <p>
                        mobil: 602 140 023<br/>
                        e-mail: j.jirankova@mistavcl.cz
                    </p>
                </div>-->
                <div class="col-lg-3 col-sm-6 contact-box">
                    <h3>Roman Volenec – hlavní stavbyvedoucí</h3>
                    <p>
                        mobil: 737 245 691<br/>
                        e-mail: r.volenec@mistavcl.cz
                    </p>
                </div>
                <div class="col-lg-3 col-sm-6 contact-box">
                    <h3>Dana Kubátová – rozpočty staveb </h3>
                    <p>
                        mobil: 737 245 692 <br/>
                        e-mail: d.kubatova@mistavcl.cz
                    </p>
                </div>
                <div class="col-lg-3 col-sm-6 contact-box">
                    <h3>Dana Janouchová – administrace</h3>
                    <p>
                        mobil: 733 534 496<br/>
                        telefon: 487 522 375<br/>
                        e-mail: d.janouchova@mistavcl.cz
                    </p>
                </div>
                <div class="col-lg-3 col-sm-6 contact-box">
                    <h3>Petra Makovcová – účetní úsek</h3>
                    <p>
                        mobil: 734 716 235<br/>
                        telefon: 487 522 375<br/>
                        e-mail: p.makovcova@mistavcl.cz
                    </p>
                </div>
                <div class="col-lg-3 col-sm-6 contact-box">
                    <h3>Lenka Michlíková – technický úsek </h3>
                    <p>
                        mobil: 737 245 690<br/>
                        e-mail: l.michlikova@mistavcl.cz
                    </p>
                </div>
                <div class="col-lg-3 col-sm-6 contact-box">
                    <h3>Pavlína Mazurová - obchodní zástupce</h3>
                    <p>
                        mobil: 602 140 023<br/>
                        e-mail: p.mazurova@mistavcl.cz
                    </p>
                </div>
                <div class="col-lg-3 col-sm-6 contact-box">
                    <h3>Milan Flégl – vedoucí prodeje</h3>
                    <p>
                        mobil: 725 814 755<br/>
                        e-mail: m.flegl@mistavcl.cz
                    </p>
                </div>
                <div class="col-lg-3 col-sm-6 contact-box">
                    <h3>Jiří Mečíř – stavební technik</h3>
                    <p>
                        mobil: 736 481 988<br/>
                    </p>
                </div>
                <div class="col-lg-3 col-sm-6 contact-box">
                    <h3>Jan Kněžour – zásobování</h3>
                    <p>
                        mobil: 739 477 502<br/>
                    </p>
                </div>
            </div>
        </div>
        <!-- End: Kontakt -->

        <footer class="footer">
            <div class="row">
                <div class="col-sm-6">
                    <h3>Ke stažení</h3>
                    <a class="btn btn-link footer-link" href="https://www.mistavcl.cz/dokumenty/vypis-ze-zr.pdf" target="_blank">Výpis z ŽR</a>
                    <a class="btn btn-link footer-link" href="https://www.mistavcl.cz/dokumenty/vypis-z-or.pdf" target="_blank">Výpis z OR</a>
                    <a class="btn btn-link footer-link" href="https://www.mistavcl.cz/dokumenty/osvedceni-o-autorizaci.pdf" target="_blank">Osvědčení o autorizaci</a>
                    <a class="btn btn-link footer-link" href="https://www.mistavcl.cz/dokumenty/certifikat-systemu-managementu-kvality.pdf" target="_blank">Certifikát systému kvality</a>
                    <a class="btn btn-link footer-link" href="https://www.mistavcl.cz/dokumenty/kooperativa-mistav-potvrzeni-o-pojisteni.pdf" target="_blank">Kooperativa - potvrzení o pojištění</a>
                    <a class="btn btn-link footer-link" href="https://www.mistavcl.cz/dokumenty/certifikat-proskoleni-baumit.pdf" target="_blank">Certifikát + proškolení Baumit</a>
                </div>
                <div class="col-sm-5 offset-sm-1">
                    <h3>Odkazy</h3>
                    <a class="btn btn-link footer-link" href="#stavby">Stavby</a>
                    <a class="btn btn-link footer-link" href="#reality">Reality</a>
                    <a class="btn btn-link footer-link" href="#sluzby">Služby</a>
                    <a class="btn btn-link footer-link" href="#prodej">Prodej</a>
                    <a class="btn btn-link footer-link" href="#kontakt">Kontakt</a>
                </div>
                <div class="col-sm-12">
                    <p class="text-right">&copy; Mistav 2023</p>
                </div>
            </div>
        </footer>
    </div> <!-- /container -->

    <!-- Modal Component - realizace galerie -->
    <b-modal ref="hotels" size="lg" hide-footer title="Galerie realizací - hotely">
        <b-carousel id="carousel2"
                            style="width: 100%;
                                overflow: hidden;"
                            controls
                            indicators
                            background="#ffffff"
                            :interval="4000"
                            img-width="1920"
                            img-height="800"
                            v-model="slide2"
                            @sliding-start="onSlideStart"
                            @sliding-end="onSlideEnd"
                >
                <!-- Hotely -->
                <b-carousel-slide caption="Hotel Morris Mariánské Lázně" :img-src="require('./assets/reference/Hotel-Morris-Marianske-lazne.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Hotel Morris Česká Lípa" :img-src="require('./assets/reference/Hotel-Morris-Ceska-Lipa.jpg')">
                </b-carousel-slide>                
            </b-carousel>
            <b-btn class="mt-3" variant="outline-warning" block @click="hideHotels">Zavřít</b-btn>
    </b-modal>

    <b-modal ref="factories" size="lg" hide-footer title="Galerie realizací - průmysl">
        <b-carousel id="carousel15"
                            style="width: 100%;
                                overflow: hidden;"
                            controls
                            indicators
                            background="#ffffff"
                            :interval="4000"
                            img-width="1920"
                            img-height="800"
                            v-model="slide15"
                            @sliding-start="onSlideStart"
                            @sliding-end="onSlideEnd"
                >
                <!-- Průmysl -->
                <b-carousel-slide caption="Sauer, vestavba haly – Žandov" :img-src="require('./assets/reference/Sauer.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Sauer, nová hala – Žandov" :img-src="require('./assets/reference/Sauer-nova_hala.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Festool, přístavba haly – Česká Lípa" :img-src="require('./assets/reference/Festool-prist.haly.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Festool, stavba koridoru – Česká Lípa" :img-src="require('./assets/reference/Festool-koridor.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Hangár, letiště - Česká Lípa" :img-src="require('./assets/reference/Hangar.jpg')">
                </b-carousel-slide>
            </b-carousel>
            <b-btn class="mt-3" variant="outline-warning" block @click="hideFactories">Zavřít</b-btn>
    </b-modal>

    <b-modal ref="newBuildings" size="lg" hide-footer title="Galerie realizací - novostavby">
        <b-carousel id="carousel14"
                            style="width: 100%;
                                overflow: hidden;"
                            controls
                            indicators
                            background="#ffffff"
                            :interval="4000"
                            img-width="1920"
                            img-height="800"
                            v-model="slide14"
                            @sliding-start="onSlideStart"
                            @sliding-end="onSlideEnd"
                >
                    <!-- Novostavby -->
                    <b-carousel-slide caption="Golf Resort – Česká Lípa" :img-src="require('./assets/reference/Golfresort.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Rodinný dům – Skalice u České Lípy" :img-src="require('./assets/reference/RD-hrdlicka-1.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Rodinný dům – Horní Libchava" :img-src="require('./assets/reference/RD_LIBCHAVA-Novak.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Rodinný dům – Cvikov" :img-src="require('./assets/reference/RDDeak.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Rodinný dům – Česká Lípa (pod vysílačem Špičák)" :img-src="require('./assets/reference/RDSrbek.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Rodinný dům – Krompach" :img-src="require('./assets/reference/Krompach.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Základní škola Tyršova – šatny, Česká Lípa" :img-src="require('./assets/reference/satny-tyrsovka.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Základní škola Jižní – Česká Lípa" :img-src="require('./assets/reference/ZsJizni.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Přístavba Základní školy ve Skalici u České Lípy" :img-src="require('./assets/reference/ZSkalice-uvod.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Nová základna Báňské záchranné služby v areálu DIAMO" :img-src="require('./assets/reference/diamo1.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Nová základna Báňské záchranné služby v areálu DIAMO" :img-src="require('./assets/reference/diamo2.jpg')">
                    </b-carousel-slide>
                </b-carousel>
            <b-btn class="mt-3" variant="outline-warning" block @click="hideNewBuildings">Zavřít</b-btn>
    </b-modal>

    <b-modal ref="facades" size="lg" hide-footer title="Galerie realizací - fasády">
        <b-carousel id="carousel13"
                            style="width: 100%;
                                overflow: hidden;"
                            controls
                            indicators
                            background="#ffffff"
                            :interval="4000"
                            img-width="1920"
                            img-height="800"
                            v-model="slide13"
                            @sliding-start="onSlideStart"
                            @sliding-end="onSlideEnd"
                >
                    <!-- Fasády -->
                    <b-carousel-slide caption="Festool Vila – Moskevská, Česká Lípa" :img-src="require('./assets/reference/Festool-vila.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Budova Unionka – Česká Lípa" :img-src="require('./assets/reference/Unionka.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Poliklinika NSP – Česká Lípa" :img-src="require('./assets/reference/NSP-CeskaLipa.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Základní škola Slovanka - Česká Lípa" :img-src="require('./assets/reference/ZsSlovanka.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Panelový dům – Sadová, Nový Bor" :img-src="require('./assets/reference/NovyBor-sadova.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Střední průmyslová škola – Česká Lípa - 1. část" :img-src="require('./assets/reference/SPS-CeskaLipa.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Střední průmyslová škola – Česká Lípa - 2. část" :img-src="require('./assets/reference/SPS-CeskaLipa2.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Základní škola –Nový Oldřichov" :img-src="require('./assets/reference/ZsMsNovyOldrichov.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Panelový dům – OSBD Východní, Česká Lípa" :img-src="require('./assets/reference/Vychodni-CeskaLipa.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="DIAMO, statní podnik o.z. – Stráž pod Ralskem" :img-src="require('./assets/reference/Diamo.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Kooperativa – Česká Lípa" :img-src="require('./assets/reference/Kooperativa.jpg')">
                    </b-carousel-slide>
            </b-carousel>
            <b-btn class="mt-3" variant="outline-warning" block @click="hideFacades">Zavřít</b-btn>
    </b-modal>

    <b-modal ref="gasStations" size="lg" hide-footer title="Galerie realizací - benzínové pumpy">
        <b-carousel id="carousel11"
                            style="width: 100%;
                                overflow: hidden;"
                            controls
                            indicators
                            background="#ffffff"
                            :interval="4000"
                            img-width="1920"
                            img-height="800"
                            v-model="slide11"
                            @sliding-start="onSlideStart"
                            @sliding-end="onSlideEnd"
                >
                    <!-- Benzínové pumpy -->
                    <b-carousel-slide caption="KM Prona - Mnichovo Hradiště" :img-src="require('./assets/reference/KMProna-MnHradiste.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="KM Prona – Nový Bor" :img-src="require('./assets/reference/KMProna-NBor.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="KM Prona – Budyně nad Ohří" :img-src="require('./assets/reference/KMProna-Budyne.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="KM Prona – Praha-Hostivař" :img-src="require('./assets/reference/KMProna-Hostivar.jpg')" >
                    </b-carousel-slide>
                    <b-carousel-slide caption="KM Prona – Česká Lípa-Stará Lípa" :img-src="require('./assets/reference/KMProna-StLipa.jpg')" >
                    </b-carousel-slide>
                </b-carousel>
            <b-btn class="mt-3" variant="outline-warning" block @click="hideGasStations">Zavřít</b-btn>
    </b-modal>

    <!-- Modal Component - realizace galerie -->
    <b-modal ref="reconstructions" size="lg" hide-footer title="Galerie realizací - rekonstrukce">
        <b-carousel id="carousel12"
                            style="width: 100%;
                                overflow: hidden;"
                            controls
                            indicators
                            background="#ffffff"
                            :interval="4000"
                            img-width="1920"
                            img-height="800"
                            v-model="slide12"
                            @sliding-start="onSlideStart"
                            @sliding-end="onSlideEnd"
                >
                    <!-- Rekonstrukce -->
                    <b-carousel-slide caption="Kulturní dům – Nový Oldřichov" :img-src="require('./assets/reference/KD-NovyOldrichov.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Glass shop Crystalex – Nový Bor" :img-src="require('./assets/reference/CrystalexGlassShop.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Restaurace u Kerama – Žizníkov" :img-src="require('./assets/reference/Keramo-ziznikov.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Villa Hrdlička – Děčínská, Česká Lípa" :img-src="require('./assets/reference/VillaHrdlicka.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Centrum zdraví NSP – Česká Lípa" :img-src="require('./assets/reference/CentrumZdraviNSP.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Bytový dům – Mimoň" :img-src="require('./assets/reference/BDMimon.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Lineta (bytový dům + kavárna Reunion) – Česká Lípa" :img-src="require('./assets/reference/Lineta.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Kulturní dům – Mařenice" :img-src="require('./assets/reference/KDMarenice.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Bytový dům Jiráskova 34 - Česká Lípa" :img-src="require('./assets/reference/BDJiraskova.jpg')">
                    </b-carousel-slide>
                    <b-carousel-slide caption="Restaurace u Slunce - Skalice u České Lípy" :img-src="require('./assets/reference/uslunce.jpg')">
                    </b-carousel-slide>
                </b-carousel>
            <b-btn class="mt-3" variant="outline-warning" block @click="hideReconstructions">Zavřít</b-btn>
    </b-modal>

    <b-modal ref="modal_materials" size="lg" hide-footer title="Materiály">
        <b-carousel id="carousel3"
                            style="width: 100%;
                                overflow: hidden;"
                            controls
                            indicators
                            background="#ffffff"
                            :interval="4000"
                            img-width="1920"
                            img-height="800"
                            v-model="slide3"
                            @sliding-start="onSlideStart"
                            @sliding-end="onSlideEnd"
                >
                <b-carousel-slide caption="Písek 0/4 - betoňák" :img-src="require('./assets/materialy/pisek0-4-betonak.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Písek 0/4 - malťák" :img-src="require('./assets/materialy/maltak0-4.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Písek 0/4 - betoňák 2x praný" :img-src="require('./assets/materialy/pisek0-4-betonak-prany.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Bílý písek PR31" :img-src="require('./assets/materialy/pr31.jpg')" >
                </b-carousel-slide>
                <b-carousel-slide caption="PDK 0/32 - znělec" :img-src="require('./assets/materialy/pdk0-32.jpg')" >
                </b-carousel-slide>
                <b-carousel-slide caption="PDK 0/63 - znělec" :img-src="require('./assets/materialy/pdk0-63.jpg')" >
                </b-carousel-slide>
                <b-carousel-slide caption="PDK 2/5 - čedič" :img-src="require('./assets/materialy/pdk2-5.jpg')" >
                </b-carousel-slide>
                <b-carousel-slide caption="PDK 8/16 - znělec" :img-src="require('./assets/materialy/pdk8-16.jpg')" >
                </b-carousel-slide>
                <b-carousel-slide caption="PDK 16/32 - čedič" :img-src="require('./assets/materialy/pdk16-32.jpg')" >
                </b-carousel-slide>
                <b-carousel-slide caption="PDK 32/63 - znělec" :img-src="require('./assets/materialy/pdk32-63.jpg')" >
                </b-carousel-slide>
                <b-carousel-slide caption="Kačírek 4/8 - praný" :img-src="require('./assets/materialy/kacirek4-8-prany.jpg')" >
                </b-carousel-slide>
                <b-carousel-slide caption="Kačírek 11/22 - praný" :img-src="require('./assets/materialy/kacirek11-22-prany.jpg')" >
                </b-carousel-slide>
                <b-carousel-slide caption="Mulčovací kůra výběrová 0/80mm" :img-src="require('./assets/materialy/mulcovaci-kura0-80.jpg')" >
                </b-carousel-slide>
                <b-carousel-slide caption="Lomový kámen" :img-src="require('./assets/materialy/lomovykamen.jpg')" >
                </b-carousel-slide>
            </b-carousel>
            <b-btn class="mt-3" variant="outline-info" block @click="hideModal2">Zavřít</b-btn>
    </b-modal>

    <b-modal ref="zsskalice" size="lg" hide-footer title="Galerie Přístavby ZŠ Skalice">
        <b-carousel id="carousel222"
                            style="width: 100%;
                                overflow: hidden;"
                            controls
                            indicators
                            background="#ffffff"
                            :interval="4000"
                            img-width="1920"
                            img-height="800"
                            v-model="slide2"
                            @sliding-start="onSlideStart"
                            @sliding-end="onSlideEnd"
                >
                <!-- ZŠ Skalice -->
                <b-carousel-slide caption="Před" :img-src="require('./assets/reference/ZsSkalice/skalice2.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/ZsSkalice/skalice28.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/ZsSkalice/skalice29.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/ZsSkalice/skalice30.jpg')">
                </b-carousel-slide>
            </b-carousel>
            <b-btn class="mt-3" variant="outline-warning" block @click="hidezsskalice">Zavřít</b-btn>
    </b-modal>
    <b-modal ref="zsskalice2" size="lg" hide-footer title="Galerie Přístavby ZŠ Skalice">
        <b-carousel id="carousel222"
                            style="width: 100%;
                                overflow: hidden;"
                            controls
                            indicators
                            background="#ffffff"
                            :interval="4000"
                            img-width="1920"
                            img-height="800"
                            v-model="slide2"
                            @sliding-start="onSlideStart"
                            @sliding-end="onSlideEnd"
                >
                <!-- ZŠ Skalice -->
                <b-carousel-slide caption="Před" :img-src="require('./assets/reference/ZsSkalice/skalice2.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/ZsSkalice/skalice28.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/ZsSkalice/skalice29.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/ZsSkalice/skalice30.jpg')">
                </b-carousel-slide>
            </b-carousel>
            <b-btn class="mt-3" variant="outline-warning" block @click="hidezsskalice2">Zavřít</b-btn>
    </b-modal>
    <b-modal ref="infocentrum" size="lg" hide-footer title="Galerie Rekonstrukce-Infocentrum Česká Lípa">
        <b-carousel id="carousel333"
                            style="width: 100%;
                                overflow: hidden;"
                            controls
                            indicators
                            background="#ffffff"
                            :interval="4000"
                            img-width="1920"
                            img-height="800"
                            v-model="slide2"
                            @sliding-start="onSlideStart"
                            @sliding-end="onSlideEnd"
                >
                <!-- INFOCENTRUM -->
                <b-carousel-slide caption="Před" :img-src="require('./assets/reference/infocentrum/infocentrum.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum1.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum2.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum3.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum4.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum5.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum6.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum7.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum8.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum9.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum10.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum11.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum12.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum13.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum14.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum15.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum16.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum17.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum18.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum19.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum20.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum21.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum22.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum23.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum24.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="Po" :img-src="require('./assets/reference/infocentrum/infocentrum25.jpg')">
                </b-carousel-slide>
            </b-carousel>
            <b-btn class="mt-3" variant="outline-warning" block @click="hideinfocentrum">Zavřít</b-btn>
    </b-modal>

    <b-modal ref="RDOkresice" size="lg" hide-footer title="Galerie RD Okřešice">
        <b-carousel id="carousel2222"
                            style="width: 100%;
                                overflow: hidden;"
                            controls
                            indicators
                            background="#ffffff"
                            :interval="4000"
                            img-width="1920"
                            img-height="800"
                            v-model="slide2"
                            @sliding-start="onSlideStart"
                            @sliding-end="onSlideEnd"
                >
                <!-- RD Okřešice -->
                <b-carousel-slide caption="" :img-src="require('./assets/reference/RDNosek/nosek1.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="" :img-src="require('./assets/reference/RDNosek/nosek2.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="" :img-src="require('./assets/reference/RDNosek/nosek3.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="" :img-src="require('./assets/reference/RDNosek/nosek4.jpg')">
                </b-carousel-slide>
                <b-carousel-slide caption="" :img-src="require('./assets/reference/RDNosek/nosek5.jpg')">
                </b-carousel-slide>                               
            </b-carousel>
            <b-btn class="mt-3" variant="outline-warning" block @click="hideRDOkresice">Zavřít</b-btn>
    </b-modal>

    <!-- Modal -->
    <!-- <div class="modal fade" id="myModal" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h2 class="modal-title">galerie</h2>
            </div>
            <div class="modal-body">
              
                    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                            <img class="d-block w-100" src="https://fakeimg.pl/120x120/?text=další_foto" alt="First slide">
                            </div>
                            <div class="carousel-item">
                            <img class="d-block w-100" src="https://fakeimg.pl/120x120/?text=další_foto" alt="Second slide">
                            </div>
                        </div>
                        <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>
                
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">zavřít</button>
            </div>
          </div>
          
        </div> -->
    <!-- </div> -->
</div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      msg: 'test',
      slide: 0,
      sliding: null
    }
  },
  methods: {
    // Convenience method to scroll a heading into view.
    // Not required for scrollspy to work
    // scrollIntoView(evt) {
    //   evt.preventDefault()
    //   const href = evt.target.getAttribute('href')
    //   const el = href ? document.querySelector(href) : null
    //   if (el) {
    //     this.$refs.content.scrollTop = el.offsetTop
    //   }
    // },
        handleScroll(event) {
            // Any code to be executed when the window is scrolled
            this.menuBehav()
        },
        menuBehav: function(){
            console.log('animate');
        },
        onSlideStart (slide) {
            this.sliding = true
        },
        onSlideEnd (slide) {
            this.sliding = false
        },
        scrollMeTo(refName) {
            var element = this.$refs[refName];
            var topoff = element.offsetTop;

            window.scrollTo({left: 0, top: topoff, behavior: 'smooth'});
        },
        showHotels () {
            this.$refs.hotels.show()
        },
        hideHotels () {
            this.$refs.hotels.hide()
        },
        showFactories () {
            this.$refs.factories.show()
        },
        hideFactories () {
            this.$refs.factories.hide()
        },
        showNewBuildings () {
            this.$refs.newBuildings.show()
        },
        hideNewBuildings () {
            this.$refs.newBuildings.hide()
        },        
        showFacades () {
            this.$refs.facades.show()
        },
        hideFacades () {
            this.$refs.facades.hide()
        },        
        showGasStations () {
            this.$refs.gasStations.show()
        },
        hideGasStations () {
            this.$refs.gasStations.hide()
        },        
        showReconstructions () {
            this.$refs.reconstructions.show()
        },
        hideReconstructions () {
            this.$refs.reconstructions.hide()
        },
        showzsskalice () {
            this.$refs.zsskalice.show()
        },
        hidezsskalice () {
            this.$refs.zsskalice.hide()
        },
         showinfocentrum () {
            this.$refs.infocentrum.show()
        },
        hideinfocentrum () {
            this.$refs.infocentrum.hide()
        },
        showRDOkresice () {
            this.$refs.RDOkresice.show()
        },
        hideRDOkresice () {
            this.$refs.RDOkresice.hide()
        },
        showSPS () {
            this.$refs.SPS.show()
        },
        hideSPS () {
            this.$refs.SPS.hide()
        },

        // materialy
        showModal2 () {
            this.$refs.modal_materials.show()
        },
        hideModal2 () {
            this.$refs.modal_materials.hide()
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script>

<style lang="scss">



// VARIABLES    
$orange: rgb(242,132,17);
$screen-sm-min: 540px;
$screen-md-min: 768px;
$screen-lg-min: 960px;

// #app {
//     margin-top: 70px;
// }

section.scroll-btn {
  position: relative;
  width: 100%;
  height: 0;
}
section.scroll-btn::after {
  position: absolute;
  bottom: 100px;
  left: 0;
  content: '';
  width: 100%;
  height: 80%;
}
.demo a {
  position: absolute;
  bottom: 0;
  left: 50%;
  z-index: 2;
  display: inline-block;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  color: #fff;
  font : normal 400 20px/1 'Josefin Sans', sans-serif;
  letter-spacing: .1em;
  text-decoration: none;
  transition: opacity .3s;
}
.demo a:hover {
  opacity: .5;
}

#section07 a {
  padding-top: 80px;
}
#section07 a span {
  position: absolute;
  top: 0;
  left: 50%;
  width: 24px;
  height: 24px;
  margin-left: -12px;
  border-left: 1px solid #fff;
  border-bottom: 1px solid #fff;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-animation: sdb07 2s infinite;
  animation: sdb07 2s infinite;
  opacity: 0;
  box-sizing: border-box;
}
#section07 a span:nth-of-type(1) {
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}
#section07 a span:nth-of-type(2) {
  top: 16px;
  -webkit-animation-delay: .15s;
  animation-delay: .15s;
}
#section07 a span:nth-of-type(3) {
  top: 32px;
  -webkit-animation-delay: .3s;
  animation-delay: .3s;
}
@-webkit-keyframes sdb07 {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes sdb07 {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

h1 {
    font-weight: bold;
    text-align: center;
}

h1.headline-category {
    display: block;
    width: 100%;
    margin-bottom: 0;
    padding: 30px 15px 15px;
    font-weight: lighter;
    color: #fefefe;
    text-transform: uppercase;
    background-color: lighten($orange, 4);
}

.three-columns-text {
    line-height: 1.6rem;
}

@media screen and (min-width: $screen-md-min) {
    .three-columns-text {
        -webkit-column-count: 2; /* Chrome, Safari, Opera */
        -moz-column-count: 2; /* Firefox */
        column-count: 2;
    }
}

@media screen and (min-width: $screen-lg-min) {
    .three-columns-text {
        -webkit-column-count: 3; /* Chrome, Safari, Opera */
        -moz-column-count: 3; /* Firefox */
        column-count: 3;
    }
}

.navbar.navbar-light {
    background-color: $orange;
    

    a.nav-link {
        color: #ffffff;
    }
}

#prodej {
    .btn-materials {
        background-color: #ffffff;
        width: 100%;
        min-height: 200px;
        padding: 0;

        .img-fluid {
            max-width: 100%;
        }
    }
}

#diamo-obr {
    width: 250px;
    height: 350px;
}
#diamo-obr:hover {
    width: 270px;
    height: 370px;
    box-shadow: 3px 3px 20px black
}

.navbar-dark .navbar-toggler {
    color: rgba(255,255,255,1);
    border-color: rgba(255,255,255,1);
}

.navbar-toggler {
    font-size: .9rem;
}

.navbar-brand {
    padding-top: 0;
    padding-bottom: 0;

    .logo {
        max-width: 70px;
    }
} 

.clearfix {
  display: table;
  width: 100%;
  clear: both;
}

.gray-background {
    background-color: lightgray;
}

// Start: text wrappers
.text-wrapper {
    display: block;
    padding: 20px 20px 30px;
    margin-bottom: 20px;

    &_orange {
        background-color: rgba($orange, 0.7);
        color: #fefefe;
    }

    &_gray {
        background-color: gray;
        color: #fefefe;
    }

    &_white {
        background-color: #fff;
        color: rgb(41, 41, 41);
    }

    &_left {
        align-self: flex-start;
    }

    &_right {
        align-self: flex-end;
    }
}

.jumbotron {
    background-color: #ffffff;
    padding:0;
    margin-bottom: 0;
}

/*views style */
// Start: home section
#home {
    min-height: 100vh;
    padding: 20vh 0 0;
    flex-direction: column;
    align-items: start;
    background-image: url('./assets/reference/Golfresort.jpg');
    background-size: cover;
    background-position: 50% 50%;
    .headline {
        font-size: 1.8rem;
        font-weight: lighter;
        text-align: left;
        line-height: 2.6rem;
    }

    .text-wrapper {
        padding-right: 16vw;
        &:first-child {
            width: 100%;
        }
        p {
            font-size: 1.2rem;
            margin-bottom: 7px;
            position: relative;
        }
    } 
}
// End: home section

@media screen and (max-width: $screen-md-min){
    #home {
        .text-wrapper {
            background-color: rgba($orange, 0.85);

            .headline {
                font-size: 1.5rem;
                line-height: 1.8rem;
            }
            p {
                font-size: 1.2rem;
                line-height: 1.4rem;
                margin-bottom: 1rem;
            }
        } 
    }
}

@media screen and (max-width: $screen-md-min){
    .navbar-brand .logo {
        max-width: 50px;
    }
    
    #home {
        .text-wrapper {
            background-color: rgba($orange, 0.85);

            .headline {
                font-size: 1.5rem;
                line-height: 1.8rem;
            }
            p {
                font-size: 1rem;
                line-height: 1.2rem;
                margin-bottom: 1rem;
            }
        } 
    }

}

#stavby {

    .carousel-caption {
        top: 10vh;
        right: 0;
        left: auto;
        bottom: auto;
        text-align: left;
        text-shadow: none;
        border: none;

        h3 {
            padding: .5rem 1.5rem .5rem 1rem;
            margin-bottom: .7rem;
            text-transform: uppercase;
            background-color: gray;
            color: white;
        }

        ul {
            padding: 1rem 1.5rem 1.5rem 1rem;
            list-style: none;
            background-color: #fff;
            color: rgb(41, 41, 41);
            text-shadow: none;
            li {
                margin-bottom: .3rem;
            }
        }

        @media screen and (max-width: $screen-sm-min) {
            ul {
                display: none;
            }
        }
    }

    .carousel-control-prev {
        position: absolute;
        width: 50px;
        height: 50px;
        top: 1rem;
        right: calc(2rem + 50px);
        // right: calc(3rem + 270px);
        left: auto;
        bottom: auto;
        background-color: white;
    }

    .carousel-control-next {
        position: absolute;
        width: 50px;
        height: 50px;
        top: 1rem;
        right: calc(1rem);
        // right: calc(2rem + 200px);
        left: auto;
        bottom: auto;
        background-color: white;
    }

    .carousel-control-prev-icon, .carousel-control-next-icon {
        background-color: $orange;
        width: 50px;
        height: 50px;
    }

    .carousel-indicators {
        justify-content: flex-end;
        margin-left: auto;
        margin-right: 3rem;
    }

    .btn-gallery {
        position: absolute;
        top: 1.2rem;
        right: 1rem;
        background-color: $orange;
        text-transform: uppercase;
        border-radius: 0;
        height: 50px;
    }
}

#aktualnistavby {

    .carousel-caption {
        top: 10vh;
        right: 0;
        left: auto;
        bottom: auto;
        text-align: left;
        text-shadow: none;
        border: none;

        h3 {
            padding: .5rem 1.5rem .5rem 1rem;
            margin-bottom: .7rem;
            text-transform: uppercase;
            background-color: gray;
            color: white;
        }

        ul {
            padding: 1rem 1.5rem 1.5rem 1rem;
            list-style: none;
            background-color: #fff;
            color: rgb(41, 41, 41);
            text-shadow: none;
            li {
                margin-bottom: .3rem;
            }
        }

        @media screen and (max-width: $screen-sm-min) {
            ul {
                display: none;
            }
        }
    }

    .carousel-control-prev {
        position: absolute;
        width: 50px;
        height: 50px;
        top: 1rem;
        right: calc(2rem + 50px);
        // right: calc(3rem + 270px);
        left: auto;
        bottom: auto;
        background-color: white;
    }

    .carousel-control-next {
        position: absolute;
        width: 50px;
        height: 50px;
        top: 1rem;
        right: calc(1rem);
        // right: calc(2rem + 200px);
        left: auto;
        bottom: auto;
        background-color: white;
    }

    .carousel-control-prev-icon, .carousel-control-next-icon {
        background-color: $orange;
        width: 50px;
        height: 50px;
    }

    .carousel-indicators {
        justify-content: flex-end;
        margin-left: auto;
        margin-right: 3rem;
    }

    .btn-gallery {
        position: absolute;
        top: 1.2rem;
        right: 1rem;
        background-color: $orange;
        text-transform: uppercase;
        border-radius: 0;
        height: 50px;
    }
}

#prodej {
    text-align: center;

    .nav .nav-item {
        width: 33%;
        font-size: 2rem;
        a.nav-link {
            color: $orange;
            height: 100%;
            &.active {
                color: #000;
            }
        }
    }
    .carousel-caption {
        text-align: center;
        width: 100%;
    }

    @media screen and (max-width: $screen-sm-min) {
        .nav .nav-item {
            h2 {
                font-size: .8rem;
                margin-right: 0;
                margin-left: 0;
                margin-bottom: 0;
            }

            .img-fluid {
                max-width: 100%;
            }

            .nav-link {
                padding: 3px;
                text-transform: none;
                text-align: left;
            }
        }

        .container {
            padding-left: .5rem;
            padding-right: .5rem;
        }
    }

    .container {
        padding-top: 7vh;
        padding-bottom: 7vh
    }

    .img-fluid {
        align-self: center;
        max-width: 100%;
    }

    h2 {
        font-size: 1.4rem;
        margin: 1rem .5rem 2rem;
    }

    .headline-temporary {
        padding: 15vh 5vw 20vh;

        a {
            color: $orange;
        }
    }

    .material-wrapper {
        text-align: left;

        h3.headline {
            margin-top: 30px;
            margin-bottom: .6rem;
            padding: .5rem;
            font-size: 2rem;
            text-transform: uppercase;
            font-weight: lighter;
            background-color: lightgray;
        }

        .grid {
            margin-bottom: 2rem;
            
            .grid-row {
                padding: .1rem 1rem;
                display: grid;
                grid-template-columns: auto 120px 120px;

                @media screen and (max-width: $screen-md-min) {
                    &:nth-child(2n) {
                        background-color: #d3d3d3;
                    }
                }

                div:nth-child(2), div:nth-child(3) {
                    text-align: right;
                }

                &:hover {
                    background-color:lightgray;
                }
                .skladem{
                    color:#34d634;           
                }
                .na-dotaz{
                    color:#989898;
                }
            }
        }

        .distribution {
            .grid {
                .grid-row {
                    grid-template-columns: auto 120px 120px;
                }
            }
        }

        .brikety-rozmer-cena {
            float: right;
        }
        .brikety-cena-bezDPH{
          font-size: 1.2rem;  
        }
        .brikety-cena-sDPH{
          font-size: 1.6rem;
          color:#f38e24;  
        }
        
        .grid-brikety {
            margin-bottom: 2rem;
            
            .grid-row {
                padding: .1rem 1rem;
                display: grid;
                grid-template-columns: auto;

                @media screen and (max-width: $screen-md-min) {
                    &:nth-child(2n) {
                        background-color: #d3d3d3;
                    }
                }

                div:nth-child(2), div:nth-child(3) {
                    text-align: right;
                }

                .skladem{
                    color:#34d634;           
                }
                .na-dotaz{
                    color:#989898;
                }
            }
        }
        .grid-brikety-text {
            margin-bottom: 2rem;
            
            .grid-row {
                padding: .1rem 1rem;
                grid-template-columns: 50% 50%;

                @media screen and (max-width: $screen-md-min) {
                    &:nth-child(2n) {
                        background-color: #d3d3d3;
                    }
                }
                .vyhody-brikety{
                    color:red;
                    font-size:22px;
                    font-family: Segoe Script;
                }
                           
            }
        }
    }
}

#reality {

    .jumbotron.cover {
        width: 100%;
        flex-direction: column;
        align-items: start;
        min-height: 65vh;
        border-radius: 0;
        padding: 15vh 0 0;
        background-image: url('./assets/reference/VillaHrdlicka.jpg');
        background-size: cover;
    }

    .img-fluid {
        height: auto;
    }

    .text-wrapper {
        text-transform: uppercase;
        width: 70vw;
        right: auto;

        .headline {
            color: #fff;
            padding-left: 40px;
        }
        ul {
            list-style: none;
        }
    }

    .item-box {
        margin-top: 20px;
        h2 {
            margin-top: .3rem;
            padding: .3rem .5rem;
            font-size: 1.4rem;
            color: #000;
            background-color: lightgray;
            text-transform: uppercase;
        }
    }
}

#sluzby {
    .headline-category {
        margin-bottom: 5vh;
    }

    .headline {
        font-weight: lighter;
        margin-bottom: 5vh;
    }
    
    .autovaha {
        height: 244px !important;
    }
}

#onas {
    line-height: 1.4rem;
    .headline {
        text-transform: uppercase;
        font-weight: lighter;

        &.headline_big {
            font-size: 2.3rem;
            margin: 1rem 0;
            text-transform: none;
        }
    }

    ul {
        list-style-type: circle;
        padding-left: 1.5rem;
    }

    .history-wrapper {
        padding-top: 1rem;
        padding-bottom: 3rem;
        
        .headline {
            display: block;
            padding: 1rem 2rem;
            margin-bottom: 1rem;
            text-align: center;
            background-color: #ffffff;
        }
    }
}

@media screen and (max-width: $screen-sm-min){
    #onas {
        .headline {
            font-size: 1.4rem;
            &.headline_big {
                font-size: 1.8rem;
            }
        }
    }

    #app .carousel-caption {
        h3 {
            font-size: 1rem;
        }
        .btn-gallery {
            height: 39px;
        }
    } 
}

#app .modal .carousel-caption {
    background-color: rgba(128, 128, 128, 0.7);
}

@media screen and (min-width: $screen-sm-min){
    
    #app .carousel-caption h3 {
        padding-right: 170px;
    }

    #app .modal .carousel-caption h3 {
        padding-right: 1rem;
    }
}

#kontakt {

    ul {
        list-style: none;
        margin-top: 2rem;
        padding-left: 0;
        li {
            margin-bottom: .1rem;
        }
    }

    a {
        color: #000;
    }

    .map-wrapper {
        padding-top: 2rem;
    }

    .contacts-wrapper {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        margin-right: -15px;
        margin-left: 0;
        padding-bottom: 30px;
        background-color: lightgray;
    }

    .contact-box {
        margin-top: 3rem;
        text-align: center;
        h3 {
            font-size: 1rem;
        }
        p {
            font-size: 0.9rem;
            white-space: wrap;
        }
    }

    .kontakt-info {
        padding-top: 3rem;

        h4 {
            padding-top: 1rem;
        }
        p {
            margin-bottom: .3rem;
        }
    }
}

.img-float_right {
    float: right;
    margin-top: 10px;
    max-width: 400px;
}

.footer .row {
    background-color: darken($orange, 4);
    padding-top: 2rem;
    color: #fff;

    a.btn {
        color: #fff;
    }

    h3 {
        margin-top: 30px;
        padding-left: .7rem;
    }

    .col-md-2 p {
        align-items: flex-end;
    }
}

@media screen and (min-width: 765px) { 
    #home {
        .text-wrapper {
            &:first-child {
                width: 60%;
            }
        }
    }

    #reality {
        .text-wrapper {
            width: 40vw;
        }
    }
}

@media screen and (max-width: 991px) {
    .nav-link {
        text-transform: uppercase;

        &:focus {
            background-color: darken($orange, 3);
        }
    }
}

@media screen and (min-width: 991px) {
    .navbar {
        padding-top: 0;
        padding-bottom: 0;
        &.navbar-light {
            background-color: rgba(($orange), 0.9);
            align-items: flex-end;

            .nav-link {
                padding: 0;
                &.active {
                    background-color: #fefefe;
                    color: #000;

                    a.nav-link {
                        color: #000;
                    }
                }

                a.nav-link {
                    padding: .5rem .8rem;
                }
            }
        }
    }

    #carousel1 {
        height: 80vh;
    }
    #carousel1111 {
        height: 80vh;
    }
}

@media screen and (max-width: 765px) {
    #stavby {

        .carousel-caption {
            position: relative;
            top: 0;
            margin-bottom: 20px;
        }

        .carousel-item ul {
            position: relative;
        }
    }
    
    #aktualnistavby {

        .carousel-caption {
            position: relative;
            top: 0;
            margin-bottom: 20px;
        }

        .carousel-item ul {
            position: relative;
        }
    }

    .hidden-sm-down {
        display: none;
    }
}

footer a {
    color: #ffffff;
}


</style>



// WEBPACK FOOTER //
// src/App.vue